export default {"src":"/_next/static/media/ic-translation.61405b05.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};